//  ========================================================================= orginal(encrypt&&decrypt) =====================================
import { Emitter } from "./eventEmiter";

const crypto = require('crypto');

export default class servicConnect {
    constructor(props) {
        this.ConnectionEstd = "onConnectionEstablished";
        this.OnReceivingData = "OnReceivingData";
        this.ConnectionClosed = "onConnectionClosed";
        this.ReceiveNoConnection = "ReceiveNoConnection";
        this.webSocketClosed = "webSocketClosed";
         this.saltKey = "";
        this.ivkey = "";
        this.myGameId = "";
        this.mySiteId = "";
        this.myLang = "";
        this.myPlayerToken = "";
       
  

    }
    connection() {
        this.tournmrntid = sessionStorage.getItem("TournamentId");
        console.log(this.tournmrntid )
        // this._connection = new WebSocket('wss://indicasino.czargaming.com/ws');
        this.myGameId = sessionStorage.getItem("gameId");
        // console.log(this.myGameId);
        this.mySiteId = sessionStorage.getItem("siteId");
        // console.log(this.mySiteId)
        this.myLang = sessionStorage.getItem("lang");

        if(this.myLang == null){
            this.myLang = "en";
        }
        
        this.myPlayerToken = sessionStorage.getItem("playerToken");
        // let myPlayerToken = "a1b2";

        // let sendsite="apnakhel"
      //  let sendsite="rrrcasino";
         let sendsite="luckhunter";

         


let DomainUrl = window.location.hostname

if(DomainUrl != "localhost"){
    // this._connection = new WebSocket(`wss://balladev.prep4.live/ws/games`);
    //    this._connection = new WebSocket(`ws://10.10.20.150:9991/ws/games`);
    //  this._connection = new WebSocket(`wss://${DomainUrl}/ws/games`); 
    //  this._connection = new WebSocket(`wss://sandbox.ballagames.com/ws/games`);
    //  this._connection = new WebSocket(`wss://Stagingbgtms.prep4.live/ws/games`); // kalyani

    //  this._connection = new WebSocket(`wss://balladev.undertesting.com/ws/games`);
      this._connection = new WebSocket(`wss://ballagames.prep4.live/ws/games`);
} else { 
    
    //  this._connection = new WebSocket(`wss://balladev.undertesting.com/ws/games`);
    //    this._connection = new WebSocket(`ws://10.10.20.118:9991/ws/games`);
//    this._connection = new WebSocket(`wss://${DomainUrl}/ws/games`); 
    //    this._connection = new WebSocket(`wss://balladev.prep4.live/ws/games`); // kalyani
        // this._connection = new WebSocket(`ws://10.10.20.23:8998/ws/games`); // kalyani
        // this._connection = new WebSocket(`wss://Stagingbgtms.prep4.live/ws/games`); // kalyani
        // this._connection = new WebSocket(`wss://gearupcasino.com/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);
        // this._connection = new WebSocket(`wss://ballagames.com/ws/games?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`); 

        // this._connection = new WebSocket(`wss://balladev.undertesting.com/ws/games`);  //Development
        //  this._connection = new WebSocket(`ws://10.10.20.61:9991/ws/games`);
        // this._connection = new WebSocket(`wss://gearupcasino.undertesting.com/ws/games`);  //Stagings
        this._connection = new WebSocket(`wss://ballagames.prep4.live/ws/games`);  //Stagings
        // this._connection = new WebSocket(`wss://gearupcasino.undertesting.com/ws/games`);  //Stagings
        // this._connection = new WebSocket(`wss://ballagames.prep4.live/ws/games`);  //Stagings
        // this._connection = new WebSocket(`wss://sandbox.ballagames.com/`);  //Stagings
        
        // this._connection = new WebSocket(`wss://gearupcasino.undertesting.com/ws/games?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);  //Stagings
        // this._connection = new WebSocket(`wss://balladev.undertesting.com/ws/games?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);  //Stagings
        // this._connection = new WebSocket(`http://devp4m.czargaming.com/guc/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);  //indicasino staging
        // this._connection = new WebSocket(`wss://devp4m.czargaming.com/guc/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`); //Dev
      
        // this._connection = new WebSocket(`ws://10.10.20.40:8084/ws/games`); // kalyani
        // this._connection = new WebSocket(`ws://10.10.20.34:8980/ws/games`); // sowmya
        // this._connection = new WebSocket(`ws://10.10.20.25:8985/ws/games`); // kalyani
        // this._connection = new WebSocket(`ws://10.10.20.150:9991/ws/games`);// sowmya
        // this._connection = new WebSocket(`ws://10.10.20.18:8985/ws/games?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`); // sowmya
}
     
         
 this._connection.addEventListener('open', this.connectEventHandler.bind(this)); 
        this._connection.addEventListener('close', this.closeEventHandler.bind(this));
        this._connection.addEventListener('error', this.errorEventHandler.bind(this));
        this._connection.addEventListener('message', this.dataEventHandler.bind(this));

    }    


    setKeyValues(wsid, ivVal) {
    // console.log(wsid+"  ----   "+ivVal);
    this.saltKey = wsid;
    this.ivkey = ivVal;

    let body = {
    CN: "INIT_GAME",
    object: {
        gameId:this.myGameId,
        playerToken:this.myPlayerToken,
        site:this.mySiteId,
      tournamentId: this.myGameId == 53 ? Number(this.tournmrntid) : 0

        // lang:this.myLang
    },
    sessionId:""
        }
    this.sendof(body)
}

    connectEventHandler(event) {
        Emitter.emit(this.ConnectionEstd, event);
    }

    closeEventHandler(event) {
        Emitter.emit(this.webSocketClosed, event);
        // console.log(event);
    }
    errorEventHandler(event) {
        Emitter.emit(this.ReceiveNoConnection, event);
    }

    dataEventHandler(event) {
        // let data = JSON.parse(event['data']);
        // Emitter.emit(this.OnReceivingData, data);
        // console.log("Respose from server: ");
        // console.log(data);

        // console.log(event);
        // console.log(event.data);

        if (event.data.split(":")[0] == "wsession") {
          
            // console.log("encry",event.data.split(":"), process.env.REACT_APP_SALT, process.env.REACT_APP_KEY);
            
            let wsId = event.data.split(": ")[1];
            
            let myWs = JSON.parse(this.decrypt(event.data.split(": ")[1], process.env.REACT_APP_SALT, process.env.REACT_APP_KEY));
            // console.log(myWs)
            // console.log(myWs.wsessionId)
            this.separateEvery3rd(myWs.wsessionId)
        } else {
               
            // let Orignal_data = JSON.parse(event['data']);
            let isJsonFormat;
            let data;

            try {
                JSON.parse(event.data);
                isJsonFormat = true;
            } catch (e) {
                isJsonFormat = false;
            }
            // isJsonFormat = true; // Tesing without Encryption.
            //console.log(isJsonFormat);
            // if (isJsonFormat) {
            //     data = JSON.parse(event.data);
            // } else {
            //     const decryptedText = this.decrypt(event.data, this.saltKey, this.ivkey);
            //     data = JSON.parse(decryptedText);
            //     //console.log("Decrypted Server text:", decryptedText);
            // }

            try {
                // console.log("Received Data:", event.data); // Debugging step

                if (isJsonFormat) {
                    // Ensure event.data is valid JSON
                    if (typeof event.data === "string" && event.data.trim().startsWith("{")) {
                        data = JSON.parse(event.data);
                    } else {
                        console.error("Invalid JSON format:", event.data);
                    }
                } else {
                  
                    const decryptedText = this.decrypt(event.data, this.saltKey, this.ivkey);
                    // console.log("Decrypted Server Text:", decryptedText);

                    if (typeof decryptedText === "string" && decryptedText.trim().startsWith("{")) {
                        data = JSON.parse(decryptedText);
                    } else {
                        console.error("Invalid decrypted JSON:", decryptedText);
                    }
                }
            } catch (error) {
                
                console.error("JSON Parsing Error:", error);
            }

            setTimeout(() => {
                console.log("Respose from server: ",data);
                Emitter.emit(this.OnReceivingData, data);
            }, 100)
        }



    }
    sendof(body) {
        let data = JSON.stringify(body);
       
        console.log("Request from Client: ",body)
        // console.log(data);
        // console.log(this._connection.readyState);
        //console.log(this._connection);
        // if(this._connection.readyState === WebSocket.CLOSED || this._connection.readyState == 3 || this._connection.readyState == 0){
        //     console.log( 'WebSocket connection closed' )

        // }  

        if (this._connection.readyState == 1) {
             let cipherText = this.encrypt(data, this.saltKey, this.ivkey);
            this._connection.send(cipherText);


            // this._connection.send(data);
        } else {
            console.log('WebSocket connection closed')
        }
    }


    encrypt(plainText, key, iv2) {
    const cipher = crypto.createCipheriv('aes-256-cbc', Buffer.from(key), iv2); // Use 'aes-128-cbc' for AES-128
    let encrypted = cipher.update(plainText, 'utf-8', 'base64');
    encrypted += cipher.final('base64');
    // console.log(iv2);
    // console.log(iv2.toString('base64'));
    // return iv2.toString('base64') + ':' + encrypted;
    return encrypted;
}

    decrypt(cipherText, key, iv2) {
        cipherText = ":" + cipherText;
        // console.log("Cypher",cipherText);
        
        // const [iv, encryptedMessage] = cipherText.split(':').map(part => Buffer.from(part, 'base64'));
        const [iv, encryptedMessage] = cipherText.split(':').map(part => Buffer.from(part, 'base64'));
        // console.log("encryptedMessage:  " + encryptedMessage)
        // console.log("iv:  " + iv)
        const decipher = crypto.createDecipheriv('aes-256-cbc', Buffer.from(key), iv2);
        let decrypted = decipher.update(encryptedMessage);
        // console.log(decrypted); 
        // console.log(decrypted); 
        decrypted = Buffer.concat([decrypted, decipher.final()]);
        // console.log(decrypted);
        return decrypted.toString();
    }

    separateEvery3rd(inputString) {
    let sltVal = '';
    for (let i = 2; i < inputString.length; i += 3) {
      sltVal += inputString[i];
    }

    let wssId = '';
    for (let i = 0; i < inputString.length; i++) {
      if ((i + 1) % 3 !== 0) {
        wssId += inputString[i];
      }
    }
    // console.log(sltVal + " *** " + wssId);
    // this.saltKey = sltVal
    // this.ivkey = wssId
    this.setKeyValues(wssId, sltVal);

    //return sltVal;
  }

}

// ========================================================================= original(encrypt&&decrypt) ========================================










//  ========================================================================= orginal =====================================
// import { Emitter } from "./eventEmiter";


// export default class servicConnect {
//     constructor(props) {
//         this.ConnectionEstd = "onConnectionEstablished";
//         this.OnReceivingData = "OnReceivingData";
//         this.ConnectionClosed = "onConnectionClosed";
//         this.ReceiveNoConnection = "ReceiveNoConnection";
//         this.webSocketClosed = "webSocketClosed";
//     }
//     connection() {
//         // this._connection = new WebSocket('wss://indicasino.czargaming.com/ws');
//         let myGameId = sessionStorage.getItem("gameId");
//         console.log(myGameId);
//         let mySiteId = sessionStorage.getItem("siteId");
//         console.log(mySiteId)
//         let myLang = sessionStorage.getItem("lang");

//         if(myLang == null){
//             myLang = "en";
//         }
        
//         let myPlayerToken = sessionStorage.getItem("playerToken");
//         // let myPlayerToken = "a1b2";

//         // let sendsite="apnakhel"
//       //  let sendsite="rrrcasino";
//          let sendsite="luckhunter";

         

//         // this._connection = new WebSocket(`wss://gearupcasino.com/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);
//         // this._connection = new WebSocket(`wss://ballagames.com/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);  
//         //  this._connection = new WebSocket(`wss://balladev.undertesting.com/ws/games?gameId=6&playerToken=500925b1-2801-45b5-8260-fa77e3cc4741&site=brlmaster&lang=en`);  //Stagings
//         // this._connection = new WebSocket(`wss://gearupcasino.undertesting.com/ws/games?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);  //Stagings
//         // this._connection = new WebSocket(`wss://balladev.undertesting.com/ws/games?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);  //Stagings
//         // this._connection = new WebSocket(`ws://10.10.20.34:8988/ws/games?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`); // sowmya 
//         this._connection = new WebSocket(`ws://10.10.20.34:8980/ws/games?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);
 
//         // this._connection = new WebSocket(`wss://gearupcasino.undertesting.com/ws/games?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);  //Stagings
//                                     //   `wss://gearupcasino.undertesting.com/ws/games?gameId=23&playerToken=3ad49aee-8dfa-4ce8-9637-d483f732f42a&site=luckhunter&lang=en`
//         // this._connection = new WebSocket(`http://devp4m.czargaming.com/guc/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);  //indicasino staging
//         // this._connection = new WebSocket(`wss://devp4m.czargaming.com/guc/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`); //Dev
//         //  this._connection = new WebSocket(`ws://10.10.20.60:8987/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${sendsite}&lang=${myLang}`); // Three of Kind 
//         // this._connection = new WebSocket(`ws://10.10.20.172:8989/ws/games?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`); // sowmya
//         // this._connection = new WebSocket(`ws://10.10.20.174:8987/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`); // sowmya 
//         // this._connection = new WebSocket(`ws://10.10.20.194:8989/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`); // arun
//         // this._connection = new WebSocket('ws://10.10.20.72:8989/ws?gameId=19&playerToken=nmmn&site=mcasino');
//         // this._connection = new WebSocket(`ws://10.10.20.60:8989/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);
//         // this._connection = new WebSocket('ws://10.10.20.201:8084/ws');
//         // this._connection = new WebSocket('ws://10.10.20.72:8989/ws');

//         this._connection.addEventListener('open', this.connectEventHandler.bind(this));
//         this._connection.addEventListener('close', this.closeEventHandler.bind(this));
//         this._connection.addEventListener('error', this.errorEventHandler.bind(this));
//         this._connection.addEventListener('message', this.dataEventHandler.bind(this));
//     }    


//     connectEventHandler(event) {
//         Emitter.emit(this.ConnectionEstd, event);
//     }

//     closeEventHandler(event) {
//         Emitter.emit(this.webSocketClosed, event);
//         console.log(event);
//     }
//     errorEventHandler(event) {
//         Emitter.emit(this.ReceiveNoConnection, event);
//     }

//     dataEventHandler(event) {
//         let data = JSON.parse(event['data']);
//         Emitter.emit(this.OnReceivingData, data);
//         console.log("Respose from server: ");
//         console.log(data);
//     }
//     sendof(body) {
//         let data = JSON.stringify(body);
       
//         console.log("Request from Client: ")
//         console.log(data);
//         // console.log(this._connection.readyState);
//         //console.log(this._connection);
//         // if(this._connection.readyState === WebSocket.CLOSED || this._connection.readyState == 3 || this._connection.readyState == 0){
//         //     console.log( 'WebSocket connection closed' )

//         // } 
//         if (this._connection.readyState == 1) {
//             this._connection.send(data);
//         } else {
//             console.log('WebSocket connection closed')
//         }
//     }

// }



// ========================================================================= original ========================================




// import { Emitter } from "./eventEmiter";

// import AllGamesres39 from "../../../assets/Allgamejson39.json"


// export default class servicConnect {
//     constructor(props) {
//         this.ConnectionEstd = "onConnectionEstablished";
//         this.OnReceivingData = "OnReceivingData";
//         this.ConnectionClosed = "onConnectionClosed";
//         this.ReceiveNoConnection = "ReceiveNoConnection";
//         this.webSocketClosed = "webSocketClosed";

//         this.AllGameResJson = AllGamesres39
//         this.GameID = '';
//         this.PlayerTokenDM = '';
//         this.SiteIdDM = '';
//     }
//     connection() {
//         // this._connection = new WebSocket('wss://indicasino.czargaming.com/ws');
//         let myGameId = sessionStorage.getItem("gameId");
//         console.log(myGameId);
//         let mySiteId = sessionStorage.getItem("siteId");
//         console.log(mySiteId)
//         let myLang = sessionStorage.getItem("lang");

//         if(myLang == null){
//             myLang = "en";
//         }
        
//         let myPlayerToken = sessionStorage.getItem("playerToken");
//         // let myPlayerToken = "a1b2";


//         // -----------------------------------------------------------------------------------------------------

//         this.GameID = myGameId
//         this.SiteIdDM = mySiteId
//         this.PlayerTokenDM = myPlayerToken
//         // -----------------------------------------------------------------------------------------------------

//         // let sendsite="apnakhel"
//       //  let sendsite="rrrcasino";
//         let sendsite="luckhunter";

//         // this._connection = new WebSocket(`wss://gearupcasino.com/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);
//         // this._connection = new WebSocket(`wss://ballagames.com/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);
//     //    this._connection = new WebSocket(`wss://gearupcasino.undertesting.com/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);  //Stagings
//         // this._connection = new WebSocket(`http://devp4m.czargaming.com/guc/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);  //indicasino staging
//         // this._connection = new WebSocket(`wss://devp4m.czargaming.com/guc/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`); //Dev
//         //  this._connection = new WebSocket(`ws://10.10.20.60:8987/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${sendsite}&lang=${myLang}`); // Three of Kind 
//         // this._connection = new WebSocket(`ws://10.10.20.22:8985/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`); // sowmya
//         // this._connection = new WebSocket(`ws://10.10.20.54:8969/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`); // arun
//         // this._connection = new WebSocket('ws://10.10.20.72:8989/ws?gameId=19&playerToken=nmmn&site=mcasino');
//         // this._connection = new WebSocket(`ws://10.10.20.60:8989/ws?gameId=${myGameId}&playerToken=${myPlayerToken}&site=${mySiteId}&lang=${myLang}`);
//         // this._connection = new WebSocket('ws://10.10.20.201:8084/ws');
//         // this._connection = new WebSocket('ws://10.10.20.72:8989/ws');

//         // ----------------------- For staging connection -----------------------------
//         // this._connection.addEventListener('open', this.connectEventHandler.bind(this));
//         // this._connection.addEventListener('close', this.closeEventHandler.bind(this));
//         // this._connection.addEventListener('error', this.errorEventHandler.bind(this));
//         // this._connection.addEventListener('message', this.dataEventHandler.bind(this));
//         // ----------------------- For staging connection -----------------------------



//         //  -------------------------- For Dummy Local Coneection ---------------------
//         this.DummyWebsocketConnection()
//         //  -------------------------- For Dummy Local Coneection ---------------------
//     }


//     connectEventHandler(event) {
//         Emitter.emit(this.ConnectionEstd, event);
//     }

//     closeEventHandler(event) {
//         Emitter.emit(this.webSocketClosed, event);
//         console.log(event);
//     }
//     errorEventHandler(event) {
//         Emitter.emit(this.ReceiveNoConnection, event);
//     }

//     dataEventHandler(event) {
//         let data = JSON.parse(event['data']);
//         Emitter.emit(this.OnReceivingData, data);
//         console.log("Respose from server: ");
//         console.log(data);
//     }
//     sendof(body) {
//         let data = JSON.stringify(body);
       
//         console.log("Request from Client: ")
//         console.log(data);
//         // console.log(this._connection.readyState);
//         //console.log(this._connection);
//         // if(this._connection.readyState === WebSocket.CLOSED || this._connection.readyState == 3 || this._connection.readyState == 0){
//         //     console.log( 'WebSocket connection closed' )

//         // } 


//         //  -----------------------------------For staging connection ----------------------------------
//         // if (this._connection.readyState == 1) {
//         //     this._connection.send(data);
//         // } else {
//         //     console.log('WebSocket connection closed')
//         // }
//         //  -----------------------------------For staging connection ----------------------------------






//         //  ----------------------------------For Dummy Local Coneection ----------------------------------
//         this.onMessage(data)
//         //  ----------------------------------For Dummy Local Coneection ----------------------------------


//     }

//     // ---------------------------- Dummy connections -----------------------------------

    
//     DummyWebsocketConnection() {

//         this._connection = {
//             eventListeners: {},

//             addEventListener: function (event, callback) {
//                 console.log(`Adding event listener for: ${event}`);
//                 this.eventListeners[event] = callback;
//             },

//             simulateOpen: function () {
//                 this.GameID = sessionStorage.getItem("gameId");
//                     this.SiteIdDM = sessionStorage.getItem("siteId");
//                     this.PlayerTokenDM = sessionStorage.getItem("playerToken");
//                 setTimeout(() => {
//                     console.log(" Simulated WebSocket Opened");
//                     if (this.eventListeners["open"]) {
//                         this.eventListeners["open"]({
//                             type: "open", currentTarget: {
//                                 url: `wss://gearupcasino.undertesting.com/ws?gameId=${this.GameID}&playerToken=${this.PlayerTokenDM}&site=${this.SiteIdDM}&lang=en`
//                             }
//                         });
//                     }
//                 }, 1000);
//             },

//             simulateMessage: function () {
//                 setTimeout(() => {
//                     console.log(" Simulated Message Received");

//                     const simulatedMessage = {
//                         status: 200,
//                         msg: "success",
//                         data: {
//                             sessionId: "9ec711cd03dc485cb34cfaed22050af6",
//                             playerId: 142433122
//                         }
//                     };

//                     if (this.eventListeners["message"]) {
//                         this.eventListeners["message"]({
//                             type: "message",
//                             data: JSON.stringify(simulatedMessage)
//                         });
//                     }
//                 }, 2000);
//             }
//         };

//         // Add listeners

//         this._connection.addEventListener("open", (event) => {
//             console.log(" WebSocket Opened:", event);
//         });
//         this._connection.addEventListener("message", (event) => {
//             console.log("📩 WebSocket Message Received:", event);
//         });

//         this._connection.addEventListener('open', this.connectEventHandler.bind(this));
//         this._connection.addEventListener('message', this.dataEventHandler.bind(this));

//         // Manually trigger events
//         this._connection.simulateOpen();
//         this._connection.simulateMessage();

//     }

//     onMessage(data) {
//         try {
//             const request = JSON.parse(data)
//             console.log("Received Request:", request);
//             this.generateResponse(request);
//         } catch (error) {
//             console.error("Error processing message:", error);
//         }
//     }

//     generateResponse(request) {
//         let ResponseData = []; // Use `let` instead of `const`

//         console.log("Processing Request:", request);
//         console.log("CN:", request.CN);

//         if (request.CN && request.object?.action) {
//             console.log("Fetching Response for Action:", request.object.action);

//             ResponseData = this.AllGameResJson[this.GameID][request.object.action] || { error: "Action not found" };
//         } else {
//             console.log("Fetching Response for CN:", request.CN);

//             ResponseData = this.AllGameResJson[this.GameID][request.CN] || { error: "CN not found" };
//         }

//         console.log("Emitting Response:", ResponseData);
//         Emitter.emit(this.OnReceivingData, ResponseData);
//     }

//     // ---------------------------- Dummy connections -----------------------------------

// }
